import _throttle from 'lodash/throttle'

export const tableHeight = {
  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setTableHeight)
  },

  methods: {
    setTableHeight: _throttle(function () {
      this.$nextTick(() => {
        if (this.$refs?.table) {
          const footerHeight = 67
          const topHeight = this.$refs.table.$el.getBoundingClientRect().top
          this.$refs.table.$el.style.height = window.innerHeight - topHeight - footerHeight + 'px'
        }
      })
    }, 50)
  }
}
